import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Check } from "lucide-react";

const steps = [
  // { label: "Step 01 Lorem Lips", progress: 25 },
  // { label: "Step 02 Lorem", progress: 15 },
  // { label: "Step 03 Lipsum", progress: 25 },
  // { label: "Step 04 Lorem Lip", progress: 25 },
  // { label: "Step 05 Lo", progress: 25 },
  // { label: "Step 06 Lor", progress: 25 },
];

const totalProgress = 30;

const ProfileProgress = ({ percentage }) => {
  return (
    <React.Fragment>
    <Col lg={3} className="d-flex justify-content-center">
    <Card className="rounded-2xl shadow-lg border">
      <CardBody className="pl-4 pr-4">
        <h5 className="text-lg font-semibold ">Complete your profile</h5>
        <div className="p-5">
          <CircularProgressbar
            value={percentage}
            text={`${percentage}%`}
            strokeWidth={25} 
            styles={buildStyles({
              textColor: '#000',
              pathColor: '#22C55E',
              trailColor: '#E5E7EB',
              textSize: '1.0rem',
              fontWeight:"900", // Text size set to 1.0rem
              strokeLinecap: 'butt', // Flat ends for the progress bar
            })}
          />
        </div>
        <div className="w-full flex flex-col gap-2 text-sm">
          {steps.map((step, index) => (
            <div key={index} className="flex items-center justify-between mb-2">
              <span className="flex items-center gap-3">
                <Check className="w-4 h-4 text-black" /> {step.label}
              </span>{' '}
              <span className="text-gray-500 ml-5 font-bold">{step.progress}%</span>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
    </Col>
    </React.Fragment>
  );
};

export default ProfileProgress;
